import { useEffect, useState } from 'react';
import { Box, Switch } from '@mui/material';
import { getErrorMessage } from 'common/utils';
import { useUpdateCanSuggestProducts } from 'hooks/useUsers';
import CustomDialog from 'components/dialogs/CustomDialog';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { snackbarService } from 'services/snackbarService';

interface Props {
  userId: string;
  canSuggestProducts: boolean;
  name: string;
}

// Laid out as the role picker beside it: the switch asks first, then saves.
export default function ChangeCanSuggestProducts({ userId, canSuggestProducts, name }: Props) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState<boolean>(canSuggestProducts);

  useEffect(() => {
    setCurrent(canSuggestProducts);
  }, [canSuggestProducts]);

  const { mutate, isLoading } = useUpdateCanSuggestProducts(
    () => {
      setCurrent(!current);
      setOpen(false);
      snackbarService.showSnackbar('Saved successfully', 'success');
    },
    (error: any) => {
      setOpen(false);
      snackbarService.showSnackbar(getErrorMessage(error), 'error');
    },
  );

  const confirm = () => {
    mutate({ userId, canSuggestProducts: !current });
  };

  return (
    <>
      <Box>
        <Switch
          checked={!!current}
          onChange={() => setOpen(true)}
          disabled={isLoading}
        />
      </Box>

      <CustomDialog
        open={open}
        title="Suggest products"
        message={current
          ? `Stop ${name} from suggesting products?`
          : `Let ${name} suggest products?`}
        buttons={[
          <CustomButton
            key="cancel"
            variant="outlined"
            text="Cancel"
            onClick={() => setOpen(false)}
            disabled={isLoading}
            height={35}
          />,
          <CustomButton
            key="confirm"
            variant="filled"
            color="primary"
            text="Confirm"
            onClick={confirm}
            loading={isLoading}
            height={35}
          />,
        ]}
      />
    </>
  );
}
